<template>
  <el-container class="login_bg" type="flex" style="height:100%">
  <el-main>
    <el-page-header @back="goBack" content="订单详情">
    </el-page-header>
    <el-card shadow="always">
      <div class="success_box">
        <div class="desc">
          <i class="el-icon-circle-check"></i>
          <div>
            <div class="title">订单提交成功！请尽快完成支付。</div>
            <div>请在 <span>{{ consumeOrderInfo.payRemainingDt }}</span> 内完成支付, 超时后将自动取消订单</div>
            <div>订单编号：{{ consumeOrderInfo.id }}</div>
          </div>
        </div>
        <div class="price">应付总额：<span>¥{{ consumeOrderInfo.amount }}</span></div>
      </div>
    </el-card>
    <h3>商品信息</h3>
    <el-row class="product_information">
      <el-col :span="3" class="item">
        <div class="title">软件版本</div>
        <div class="info">{{ packageLogInfo.packageName }}</div>
      </el-col>
      <el-col :span="3" class="item">
        <div class="title">套餐PC账号</div>
        <div class="info">{{ packageLogInfo.pcActNum }}</div>
      </el-col>
      <el-col :span="3" class="item">
        <div class="title">套餐司机账号</div>
        <div class="info">{{ packageLogInfo.driverActNum }}</div>
      </el-col>
      <el-col :span="3" class="item">
        <div class="title">
          <el-badge :value="12" type="warning">
            <div>业务员账号数量</div>
          </el-badge>
        </div>
        <div class="info">{{ packageLogInfo.salesActNum }}</div>
      </el-col>
      <el-col :span="3" class="item">
        <div class="title">
          <el-badge :value="12" type="warning">
            <div>PC加购账号数</div>
          </el-badge>
        </div>
        <div class="info">{{ packageLogInfo.incPcActNum }}</div>
      </el-col>
      <el-col :span="3" class="item">
        <div class="title">
          <el-badge :value="12" type="warning">
            <div>司机加购账号数</div>
          </el-badge>
        </div>
        <div class="info">{{ packageLogInfo.incDriverActNum }}</div>
      </el-col>
      <el-col :span="3" class="item">
        <div class="title">
          <el-badge :value="12" type="warning">
            <div>业务员账号加购数</div>
          </el-badge>
        </div>
        <div class="info">{{ packageLogInfo.incSalesActNum }}</div>
      </el-col>
      <el-col :span="3" class="item">
        <div class="title">购买时长</div>
        <div class="info">{{ packageLogInfo.purchaseTime }}</div>
      </el-col>
    </el-row>
    <h3>请选择支付方式</h3>
    <el-row :gutter="12">
      <el-col :span="8" v-for="item in paymentChannelList" :key="item.id">
        <el-card shadow="hover" @click.native="selectPaymnet(item)">
          {{ item.configName }}
        </el-card>
      </el-col>
    </el-row>
    <el-dialog title="支付" :visible.sync="dialogVisible" width="60%" center>
      <div v-if="isPay == 0" style="text-align: center;">
        <div>本订单交易号: <span style="color:#D9001B;">{{ consumeOrderInfo.id }}</span> (温馨提示: 若有疑问可以 <span
            style="color:#D9001B;">拨打客服电话{{ customerServiceNumber }}</span>)</div>
        <div>请扫描下方二维码 完成付款, 完成后点击按钮查看订单是否支付成功 </div>
        <el-card style="width:240px;margin: 20px auto">
          <vue-qr :text="qrUrl" :callback="qrcodeChange" qid="testid"></vue-qr>
          <div class="tip" style="display:flex;justify-content: space-around;">
            <i class="el-icon-full-screen" style="font-size: 40px;color:#ffd04b"></i>
            <div>打开手机<br>扫一扫继续付款</div>
          </div>
        </el-card>
        <router-link :to="{ path: '/company/purchase_record' }">
          <el-button class="yellow_btn">我已支付成功 </el-button>
        </router-link>
      </div>
      <!-- <div v-else>
        <h1 style="display: flex;align-items: center;justify-content: center;">
          <i class="el-icon-circle-check" style="color:#67c23a;font-size:50px;margin-right:20px"></i>
          订单支付成功，感谢支持！
        </h1>
        <div style="width:210px;margin:0 auto;line-height: 40px;">
          <div>支付时间：{{  }}</div>
          <div>支付方式：{{ paymentChannel.configName }}</div>
          <div>支付金额：<span style="color:#D9001B;">¥5800.00</span></div>
        </div>
        <div style="text-align:center;margin-top:20px">
          <router-link :to="{ path: '/company/purchase_record_details', query: { id: consumeOrderInfo.id } }">
            <el-button class="yellow_btn" style="width:210px">查看订单</el-button>
          </router-link>
        </div>
      </div> -->
    </el-dialog>
  </el-main>

  <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getPurchaseRecordInfo,
  payOrder,
  getPaymentChannelList
  // submit
} from '@/api.js';
import VueQr from 'vue-qr';
import {
  mapState
} from 'vuex';

export default {
  name: "CompanyPayDetailes",
  components: { VueQr },
  data() {
    return {
      dialogVisible: false,
      isPay: 0,
      consumeOrderInfo: {},
      packageLogInfo: {},
      paymentChannelList: [],
      paymentChannel: {},
      qrUrl: ''
    }
  },
  created() {
    this.getPurchaseRecordInfo()
    this.getPaymentChannelList()
  },
  mounted() {

  },
  methods: {
    goBack() {
      this.$router.back()
    },
    getPurchaseRecordInfo() {
      getPurchaseRecordInfo({
        cid: this.AdminId,
        orderId: this.$route.query.id
      }).then(res => {
        if (res.code == 0) {
          this.consumeOrderInfo = res.data.consumeOrderInfo
          this.packageLogInfo = res.data.packageLogInfo
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取支付渠道
    getPaymentChannelList() {
      getPaymentChannelList({}).then(res => {
        if (res.code == 0) {
          this.paymentChannelList = res.data.list ? res.data.list : []
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 订单支付
    payOrder() {
      payOrder({
        Cid: this.AdminId,
        OrderId: this.$route.query.id,
        PackageSn: this.packageLogInfo.packageSn,
        PaymentChannelKey: this.paymentChannel.configKey,
        PaymentChannelVal: this.paymentChannel.configValue,
        PaymentMode: 'scan_collect',
      }).then(res => {
        if (res.code == 0) {
          this.qrUrl = res.data.qrUrl
          this.dialogVisible = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    selectPaymnet(item) {
      this.paymentChannel = item
      this.payOrder()
    },
    qrcodeChange(dataUrl, id) {
      console.log(dataUrl, id)
    }
  },
  computed: {
    ...mapState({
      AdminId: state => state.AdminId,
      code: state => state.code,
      customerServiceNumber: state => state.customerServiceNumber

    }),
  },
}
</script>

<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}
.el-card {
  margin-top: 20px;
}

.success_box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .desc {
    display: flex;
    font-size: 16px;
    align-items: center;

    div {
      margin-bottom: 10px;
    }

    div:last-child {
      margin-bottom: 0;
    }

    i {
      font-size: 90px;
      color: rgb(255, 208, 75);
      margin-right: 20px;
    }

    .title {
      font-size: 24px;
    }

    span {
      color: #D9001B;
    }
  }

  .price {
    span {
      color: #D9001B;
      font-size: 24px;
      font-weight: 600;
    }
  }
}

.product_information {
  border: 1px solid #e5e9f2;

  .item {
    text-align: center;
  }

  .title {
    height: 40px;
    background: rgba(245, 248, 250, 1);
    padding-top: 15px;
  }

  .info {
    line-height: 60px;
  }
}
</style>